const trackGoogle = () => {
  if ((window as any).gtag_report_conversion) {
    (window as any).gtag_report_conversion();
  }
};

export default trackGoogle;
